import React from 'react';

import Group from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

import {GET_STARTED_CONTENT} from '../../../constants';
import {samlSection} from '../get-started.module.styl';

export const WhatIsSaml: React.FC = () => {
    return (
        <div className={samlSection}>
            <Group direction="v" gap="xs">
                <Typography variant="heading-level-4">
                    {GET_STARTED_CONTENT.whatIsSaml.heading}
                </Typography>
                <Typography variant="body-level-1">
                    {GET_STARTED_CONTENT.whatIsSaml.description}
                </Typography>
            </Group>
        </div>
    );
};
